class WebsterAccessibility {
	constructor() {
		this.isEventClickOrValidKey = (event) => {
			if (event.type === 'mousedown') {
				return true;
			}
			if (event.type === 'keydown') {
				if (event.code === 'Enter' || event.code === 'Space') {
					return true;
				}
			}
			return false;
		};
	}

	/** ----//
   ------------------------------------------🧿--🧿

   Accordion Accessibility Script

   ------------------------------------------🧿--🧿
   //----*/
	static setAriaExpanded(element, value) {
		element.setAttribute('aria-expanded', value);
	}

	static setAriaPressed(element, value) {
		element.setAttribute('aria-pressed', value);
	}

	static setAccordionAccessibility(event, elOverride, expandAllAria) {
		try {
			const getAccordionTarget = elOverride || event.target;
			const isExpandQuestions = getAccordionTarget.dataset.js === 'expand-questions';
			const isExpandGroup = getAccordionTarget.dataset.js === 'expand-group';
			const isExpandAllGroups = getAccordionTarget.dataset.js === 'expand-all-groups';
			if (isExpandGroup) {
				const isExpanded = getAccordionTarget.getAttribute('aria-expanded') === 'true';
				const getAccordionGroup = getAccordionTarget.closest('.nested-faqs');
				const getAccordionAnswer = getAccordionGroup.querySelector('.accordion.accordion--nested');
				if (!isExpanded) {
					getAccordionAnswer.removeAttribute('hidden');
					this.setAriaExpanded(getAccordionTarget, true);
				} else {
					getAccordionAnswer.setAttribute('hidden', 'true');
					this.setAriaExpanded(getAccordionTarget, false);
				}
			}
			if (isExpandAllGroups || isExpandQuestions) {
				const isExpanded = getAccordionTarget.getAttribute('aria-pressed') === 'true';
				if (!isExpanded) {
					this.setAriaPressed(getAccordionTarget, true);
				} else {
					this.setAriaPressed(getAccordionTarget, false);
				}
				if (isExpandAllGroups) {
					if (expandAllAria !== undefined) {
						this.setAriaPressed(getAccordionTarget, expandAllAria);
					}
					/* ----//  Hide the groups and change button aria-expanded value  //----*/
					const getAccordionGroups = document.querySelectorAll('.nested-faqs');
					getAccordionGroups.forEach((group) => {
						const getGroupAnswers = group.querySelector('.accordion.accordion--nested');
						const getExpandGroupBtn = group.querySelector('.nested-faqs--heading button.btn--toggle-accordion');
						if (!isExpanded) {
							getGroupAnswers.removeAttribute('hidden');
							this.setAriaExpanded(getExpandGroupBtn, true);
						} else {
							getGroupAnswers.setAttribute('hidden', 'true');
							this.setAriaExpanded(getExpandGroupBtn, false);
						}
					});
				}
			}
		} catch (error) {
			console.error('Error in setAccordionAccessibility::');
			console.error(error);
		}
	}

	init(elOverride = false) {
		const elementOverride = elOverride;
		const accBtns = document.querySelectorAll('.btn--toggle-accordion');
		accBtns.forEach((accBtn) => {
			['click', 'keydown', 'mousedown'].forEach((evt) => {
				accBtn.addEventListener(evt, (event) => {
					if (this.isEventClickOrValidKey(event)) {
						WebsterAccessibility.setAccordionAccessibility(event, elementOverride);
					}
				});
			});
		});
		window.openAccordionGroups = {
			groups: {},
			openGroupListener: (val) => {},
			set openAccordions(value) {
				this.groups = value;
				this.openGroupListener(value);
			},
			get openAccordions() {
				return this.groups;
			},
			registerListener(listener) {
				this.openGroupListener = listener;
			},
		};
		window.openAccordionGroups.registerListener((value) => {
			WebsterAccessibility.setAccordionAccessibility(value.eventData, document.querySelector("button[data-js='expand-all-groups']"), value.expandAll);
		});
	}
}

export default WebsterAccessibility;
